<script lang="ts">
  interface PresentationItem {
    id: string;
    slug: string;
    title: string;
    description?: string;
    thumbnail_url?: string;
    category?: string;
    presented_at?: string;
    user: {
      display_name: string;
      username: string;
      avatar_url?: string;
    };
  }

  let { presentations = [] }: { presentations: PresentationItem[] } = $props();

  function formatDate(iso: string | undefined): string {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' });
  }

</script>

<svelte:head>
  <title>발표자료 | AX Hub</title>
  <meta name="description" content="AX Hub 발표자료 모음" />
</svelte:head>

<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <header class="bg-white border-b border-gray-200">
    <div class="max-w-5xl mx-auto px-4 py-8 sm:px-6">
      <h1 class="text-3xl font-bold text-gray-900 tracking-tight" style="font-family: 'Outfit', sans-serif;">
        Presentations
      </h1>
      <p class="mt-2 text-gray-500">발표자료 아카이브</p>
    </div>
  </header>

  <!-- Content -->
  <main class="max-w-5xl mx-auto px-4 py-8 sm:px-6">
    {#if presentations.length === 0}
      <div class="text-center py-16">
        <p class="text-gray-400 text-lg">아직 등록된 발표자료가 없습니다.</p>
      </div>
    {:else}
      <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {#each presentations as pt (pt.id)}
          <a
            href="/pt/{pt.slug}"
            class="group block bg-white border border-gray-200 overflow-hidden hover:border-gray-400 hover:shadow-md transition-all duration-200"
          >
            <!-- Thumbnail -->
            <div class="aspect-video bg-gray-100 relative overflow-hidden">
              {#if pt.thumbnail_url}
                <img
                  src={pt.thumbnail_url}
                  alt={pt.title}
                  class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              {:else}
                <div class="w-full h-full flex items-center justify-center bg-gray-900">
                  <svg class="w-12 h-12 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                    <path stroke-linecap="square" d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5" />
                  </svg>
                </div>
              {/if}
              {#if pt.category}
                <span class="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-black/70 text-white">
                  {pt.category}
                </span>
              {/if}
            </div>

            <!-- Info -->
            <div class="p-4">
              <h2 class="text-sm font-semibold text-gray-900 line-clamp-2 group-hover:text-blue-600 transition-colors">
                {pt.title}
              </h2>
              {#if pt.description}
                <p class="mt-1 text-xs text-gray-500 line-clamp-2">{pt.description}</p>
              {/if}
              <div class="mt-3 flex items-center gap-2">
                <span class="text-xs text-gray-400">@{pt.user.username}</span>
                {#if pt.presented_at}
                  <span class="text-xs text-gray-300">·</span>
                  <span class="text-xs text-gray-400">{formatDate(pt.presented_at)}</span>
                {/if}
              </div>
            </div>
          </a>
        {/each}
      </div>
    {/if}
  </main>
</div>
